export default "__VITE_ASSET__DJod8WzX__"